import FabianIcon from 'src/assets/images/team/fabo.png';
import Julia from 'src/assets/images/team/julia.png';
import OliIcon from 'src/assets/images/team/oli.png';
import DuxIcon from 'src/assets/images/team/dux.png';
import Kolja from 'src/assets/images/team/kolja.png';
import JasenkoIcon from 'src/assets/images/team/jasenko.png';

export interface TeamMember {
  id: number;
  name: string;
  description: string;
  picture: any;
  hoverBg: string;
  role: string;
}

export const OUR_TEAM: TeamMember[] = [
  {
    id: 1,
    name: 'Fabo',
    description:
      'Creative spirit who dives deep into the complexities of human communication and behavior, inspiring his innovative pursuits.',
    picture: FabianIcon,
    hoverBg: '#FF8F1C',
    role: 'CEO & CPO',
  },
  {
    id: 2,
    name: 'Julia',
    description:
      'Her magnetic attraction to make the world a better place empowers her to deal with any challenge and embraces exciting adventures.',
    picture: Julia,
    hoverBg: '#DF1995',
    role: 'Finances',
  },
  {
    id: 4,
    name: 'Jasenko',
    description:
      'Crafting user experiences as effortlessly cool as his snowboarding and as fluid as his guitar melodies.',
    picture: JasenkoIcon,
    hoverBg: '#00A9E0',
    role: 'Creative Lead',
  },
  {
    id: 6,
    name: 'Oli',
    description:
      'Personal growth advocate, balancing logical thinking and clear communication, all in tune with passion for music.',
    picture: OliIcon,
    hoverBg: '#48D597',
    role: 'CEO & COO',
  },
  {
    id: 8,
    name: 'Dustin',
    description: 'Tech & engineering enthusiast and problem-solver; also master of all pokemon and original gamer.',
    picture: DuxIcon,
    hoverBg: '#171C8F',
    role: 'Full Stack Dev',
  },
  {
    id: 9,
    name: 'Kolja',
    description:
      'Master of networking & strategy, turning business puzzles into success stories with charm and a bright smile.',
    picture: Kolja,
    hoverBg: '#BA16A3',
    role: 'Business Strategist',
  },
];

export interface StatisticsItem {
  amount: number | string;
  text: string;
}

export const STATISTICS: StatisticsItem[] = [
  {
    amount: '30+',
    text: 'Talents in our network accross Europe',
  },
  {
    amount: 9,
    text: 'Different nationalities',
  },
  {
    amount: 4,
    text: 'Locations accross Europe',
  },
];
